export const loadAnalyticsPage = () => import("@/routes/analytics/page");

export const preloadAnalyticsPage = (): void => {
  void loadAnalyticsPage();
};
